import { Link } from 'react-router-dom';
import { useHits, Configure, useInstantSearch } from 'react-instantsearch';
import { Circuitry, ArrowRight, Wine } from '@phosphor-icons/react';
import { DropdownProductHit } from './ProductHit';
import { AddToCartStepper } from '../Product/AddToCartStepper';
import { useTranslation } from 'react-i18next';

// Enhanced Hits Section with Store-based filtering
export const HitsSection = ({ title, query, minimalDropdown, isMobile, onProductClick }) => {
  const { items, sendEvent } = useHits();
  const { results } = useInstantSearch();
  const { t } = useTranslation();

  if (minimalDropdown) {
    return (
      <div
        style={{
          width: '100%',
          background: '#fff',
          padding: isMobile ? '0' : '0 0 0 0',
        }}
      >
        <div
          style={{
            display: 'flex',
            flexDirection: isMobile ? 'column' : 'row',
            flexWrap: isMobile ? 'nowrap' : 'wrap',
            gap: isMobile ? 16 : 32,
            width: '100%',
            justifyContent: isMobile ? 'flex-start' : 'center',
            alignItems: isMobile ? 'stretch' : 'flex-start',
            boxSizing: 'border-box',
            padding: isMobile ? '0' : '0',
          }}
        >
          {items.length > 0 ? (
            items.map((hit) => (
              <div
                key={hit.objectID}
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  justifyContent: 'center',
                  background: '#fff',
                  borderRadius: 18,
                  padding: isMobile ? '18px 0' : '24px 18px',
                  minWidth: isMobile ? '100%' : 160,
                  maxWidth: 220,
                  flex: 1,
                  boxShadow: 'none',
                  transition: 'box-shadow 0.2s',
                  cursor: 'pointer',
                }}
                onMouseOver={e => e.currentTarget.style.boxShadow = '0 4px 24px rgba(75,22,76,0.10)'}
                onMouseOut={e => e.currentTarget.style.boxShadow = 'none'}
                onClick={() => onProductClick && onProductClick(hit, results?.queryID)}
              >
                <img
                  src={hit.image}
                  alt={hit.name}
                  style={{
                    width: isMobile ? 70 : 90,
                    height: isMobile ? 70 : 90,
                    objectFit: 'contain',
                    marginBottom: 18,
                    borderRadius: 12,
                    background: '#faf9f7',
                    boxShadow: '0 1px 4px rgba(0,0,0,0.03)',
                  }}
                />
                <div style={{
                  fontWeight: 700,
                  fontSize: isMobile ? 16 : 18,
                  color: '#4B164C',
                  textAlign: 'center',
                  marginBottom: 8,
                  lineHeight: 1.2,
                  maxWidth: 180,
                  whiteSpace: 'normal',
                }}>{hit.name}</div>
                <div style={{
                  fontSize: 15,
                  color: '#888',
                  fontWeight: 500,
                  marginTop: 2,
                }}>{hit.price ? `${hit.price} €` : ''}</div>
                <div onClick={e => e.stopPropagation()} style={{ marginTop: 10 }}>
                  <AddToCartStepper
                    product={hit}
                    queryID={results?.queryID ?? null}
                    compact
                  />
                </div>
              </div>
            ))
          ) : (
            <div style={{ color: '#aaa', fontSize: 15, textAlign: 'center', padding: '32px 0', width: '100%' }}>
              <Wine size={40} color="#bbb" />
              <h4 style={{ margin: '16px 0 8px', color: '#888' }}>{t('no_results')}</h4>
              <p style={{ color: '#bbb' }}>{t('discover_wines')}</p>
            </div>
          )}
        </div>
      </div>
    );
  }

  return (
    <div className="search-section products-section">
      <div className="search-section-header">
        <div className="search-section-title">
          <Circuitry size={18} />
          <span>{title}</span>
        </div>
      </div>
      <Configure
        query={query || ''}
        hitsPerPage={3}
        attributesToRetrieve={['objectID', 'name', 'sku', 'image', 'price', 'attributes', 'color', 'inStock', 'store_data', 'categorias_flat']}
      />
      <div className="products-grid">
        {query && query.trim() !== '' ? (
          items.length > 0 ? (
            items.map((hit) => (
              <div key={hit.objectID}>
                <DropdownProductHit hit={hit} sendEvent={sendEvent} />
              </div>
            ))
          ) : (
            <div className="no-results">
              <p>{t('no_results')}</p>
            </div>
          )
        ) : (
          <div className="section-placeholder">
            <div className="empty-products-state">
              <Wine size={48} color="#4B164C" />
              <h4>{t('search_for_wines')}</h4>
              <p>{t('discover_wines')}</p>
            </div>
          </div>
        )}
      </div>
      {items.length > 0 && query && query.trim() !== '' && (
        <div className="view-all-section">
          <Link to={`/search?query=${encodeURIComponent(query || '')}`} className="view-all-link">
            {t('view_all')} ({items.length}+)
            <ArrowRight size={16} />
          </Link>
        </div>
      )}
    </div>
  );
}; 